import React, { useState } from 'react';
import Button from './Button';
import Icon from '../AppIcon';

const QuickActions = ({ 
  actions = [], 
  primaryActions = [], 
  className = '',
  showMoreMenu = true 
}) => {
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);

  const defaultActions = [
    {
      id: 'create',
      label: 'Create New',
      icon: 'Plus',
      variant: 'default',
      onClick: () => console.log('Create new item')
    },
    {
      id: 'export',
      label: 'Export Excel',
      icon: 'Download',
      variant: 'outline',
      onClick: () => console.log('Export to Excel')
    },
    {
      id: 'import',
      label: 'Import Data',
      icon: 'Upload',
      variant: 'outline',
      onClick: () => console.log('Import data')
    },
    {
      id: 'refresh',
      label: 'Refresh',
      icon: 'RefreshCw',
      variant: 'ghost',
      onClick: () => console.log('Refresh data')
    }
  ];

  const allActions = actions?.length > 0 ? actions : defaultActions;
  const visibleActions = primaryActions?.length > 0 ? primaryActions : allActions?.slice(0, 2);
  const moreActions = allActions?.filter(action => 
    !visibleActions?.some(visible => visible?.id === action?.id)
  );

  const handleMoreToggle = () => {
    setIsMoreMenuOpen(!isMoreMenuOpen);
  };

  const handleActionClick = (action) => {
    if (action?.onClick) {
      action?.onClick();
    }
    setIsMoreMenuOpen(false);
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Primary Actions */}
      {visibleActions?.map((action) => (
        <Button
          key={action?.id}
          variant={action?.variant || 'default'}
          size={action?.size || 'default'}
          iconName={action?.icon}
          iconPosition="left"
          onClick={() => handleActionClick(action)}
          disabled={action?.disabled}
          loading={action?.loading}
        >
          {action?.label}
        </Button>
      ))}
      {/* More Actions Menu */}
      {showMoreMenu && moreActions?.length > 0 && (
        <div className="relative">
          <Button
            variant="outline"
            size="default"
            iconName="MoreHorizontal"
            onClick={handleMoreToggle}
            className="px-3"
          />
          
          {isMoreMenuOpen && (
            <>
              {/* Backdrop */}
              <div 
                className="fixed inset-0 z-90"
                onClick={() => setIsMoreMenuOpen(false)}
              />
              
              {/* Dropdown Menu */}
              <div className="absolute right-0 top-full mt-2 w-48 bg-popover border border-border rounded-lg shadow-modal z-100 animate-scale-in">
                <div className="py-2">
                  {moreActions?.map((action) => (
                    <button
                      key={action?.id}
                      onClick={() => handleActionClick(action)}
                      disabled={action?.disabled}
                      className="flex items-center space-x-3 w-full px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-smooth disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <Icon name={action?.icon} size={16} />
                      <span>{action?.label}</span>
                    </button>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default QuickActions;